export const SERVER_URL = "https://alexa.amazon.com/api/v1/wwaconsentflow";

export const HELP_ARTICLE_URL = "https://app-content.ring.com/shared/redirects/help_center_articles/features/works_with_amazon/add_alexa_devices/index.html";
